var DialogView = require('dialogview');


var HashDialogView = DialogView.extend({
    initialize: function (options) {
        DialogView.prototype.initialize.apply(this, arguments);
        
        this.router = options.router;
    },
    show: function () {
        this.wrapper.fadeIn('fast', _.bind(function () {
            this.afterShow();
        }, this));
        
        this.opened();
    },
    afterShow: function () {
        this.focusFirst();
    },
    focusFirst: function () {
        this.$('[tabindex=0]:visible:first').first().focus();
    },
    doHide: function () {
        this.wrapper.fadeOut(200);
        this.closed();
        HashDialogView.current = null;
    },
    hide: function () {
        this.doHide();
        this.model.trigger('hashDialogHide');
    },
    opened: function () {
        if (HashDialogView.current != this) {
            HashDialogView.closeCurrent();
            HashDialogView.current = this;
        }
        DialogView.prototype.opened.call(this);
    },
    closed: function () {
        DialogView.prototype.closed.call(this);
    }
}, {
    closeCurrent: function () {
        if (HashDialogView.current) {
            HashDialogView.current.doHide();
        }
        DialogView.closeCurrent();
    }
});


module.exports = HashDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/hashdialogview.js
// module id = o6PP
// module chunks = 1